import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page visit
    const trackVisit = async () => {
      try {
        const visitData = {
          page: location.pathname,
          referrer: document.referrer || null,
          userAgent: navigator.userAgent,
          timestamp: new Date().toISOString()
        };

        await fetch(`${API_URL}/api/analytics/visit`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(visitData)
        });
      } catch (error) {
        // Silently fail - don't block page load
        console.debug('Analytics tracking failed:', error);
      }
    };

    trackVisit();
  }, [location]);

  return null; // This component doesn't render anything
};

export default AnalyticsTracker;
